import { gql } from '@apollo/client';

export const DELETE_FILE = gql`
  mutation DeleteFile($fileId: String!) {
    deleteFile(fileId: $fileId) {
      message
    }
  }
`;

export const UPLOAD_FILE = gql`
  mutation UploadFile($filename: String!, $fileSize: Int!) {
    uploadFile(filename: $filename, fileSize: $fileSize) {
      uploadUrl
      s3Filename
    }
  }
`;

export const UPDATE_FILE = gql`
  mutation UpdateFile($fileId: String!, $status: String, $records: Int) {
    updateFile(fileId: $fileId, status: $status, records: $records) {
      id
      name
      s3Key
      records
    }
  }
`;

export const CREATE_MULTIPART_UPLOAD = gql`
  mutation CreateMultipartUpload($filename: String!, $numParts: Int!) {
    createMultipartUpload(filename: $filename, numParts: $numParts) {
      s3Filename
      uploadId
      parts {
        signedUrl
        partNumber
      }
    }
  }
`;

export const COMPLETE_MULTIPART_UPLOAD = gql`
  mutation CompleteMultipartUpload(
    $s3Filename: String!
    $uploadId: String!
    $fileSize: Int!
    $parts: [PartInput]!
    $kind: String
  ) {
    completeMultipartUpload(
      s3Filename: $s3Filename
      uploadId: $uploadId
      fileSize: $fileSize
      parts: $parts
      kind: $kind
    ) {
      id
      kind
      records
      numUniqueRecords
      numSkippedRecords
    }
  }
`;

// ATAD-146: queue an import of a file from a data source's shared folder
// (CMDA when `source` is omitted) as the user's own file, named `name`.
// Returns the new File (kind 'model' for CMDA, 'id' for the ID-only sources;
// status 'pending'); the server imports it in the background. Errors are
// user-readable (bad header, duplicate name, already imported…).
export const IMPORT_MODEL_FILE = gql`
  mutation ImportModelFile($sourceKey: String!, $name: String!, $source: DataSource) {
    importModelFile(sourceKey: $sourceKey, name: $name, source: $source) {
      id
      name
      kind
      status
      sourceKey
      dataSource
      createdAt
    }
  }
`;

export const TEST_SFTP_CONNECTION = gql`
  mutation TestSftpConnection($sftpConfig: SftpConfigInput!) {
    testSftpConnection(sftpConfig: $sftpConfig) {
      success
      message
      host
      port
    }
  }
`;

export const IMPORT_FILE_FROM_SFTP = gql`
  mutation ImportFileFromSftp($sftpConfig: SftpConfigInput!) {
    importFileFromSftp(sftpConfig: $sftpConfig) {
      success
      message
      file {
        id
        name
        s3Key
        originalFileSize
        status
        createdAt
      }
    }
  }
`;

export const TEST_S3_CONNECTION = gql`
  mutation TestS3Connection($s3Config: S3SourceUrlInput!) {
    testS3Connection(s3Config: $s3Config) {
      success
      message
      contentLength
      contentType
    }
  }
`;

export const IMPORT_FILE_FROM_S3 = gql`
  mutation ImportFileFromS3($s3Config: S3SourceUrlInput!) {
    importFileFromS3(s3Config: $s3Config) {
      success
      message
      file {
        id
        name
        s3Key
        originalFileSize
        status
        createdAt
      }
    }
  }
`;
